import { HttpContextToken } from '@angular/common/http';

export const WAIT_CURSOR: HttpContextToken<boolean> = new HttpContextToken<boolean>(() => false);
